import { useAuthContext } from "app/contexts/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function AuthGuard({ children, component, element }) {
  const auth = useAuthContext();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    return (
      <Navigate
        to="/auth/login"
        state={{ redirectTo: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children || component || element || <Outlet />;
}
